import './splash-screen.css';

const SplashScreen = ({ orientation }) => {
    return (
        <div className="splash-container">
            <div className="splash-centered-box">
                <div className="dior-logo"></div>
                <div className="splash-loader dot-pulse"></div>
            </div>
        </div>
    )
}

export default SplashScreen;
